// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_ZvA","cls2":"PremiumBadge-cls2_XjJ PremiumBadge-cls1_ZvA"};